var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "sales-orders-section-wrapper" }, [
    _c("div", { staticClass: "section-header" }, [
      _c("h4", [_vm._v(_vm._s(_vm.$t("message.salesOrders")))]),
    ]),
    _vm._v(" "),
    _vm.salesOrders.length
      ? _c(
          "div",
          { staticClass: "sales-orders-section" },
          _vm._l(_vm.salesOrders, function (order) {
            return _c(
              "div",
              { key: order.id, staticClass: "order-row" },
              [
                _c("div", { staticClass: "order-info" }, [
                  _c("div", { staticClass: "order-subject" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("shopping_cart"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(order.Subject))]),
                  ]),
                  _vm._v(" "),
                  order.Status
                    ? _c("div", { staticClass: "order-status" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("label"),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(order.Status))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-footer" }, [
                    _c("div", { staticClass: "order-owner" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("person"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$_.get(order, "Owner.name", ""))),
                      ]),
                    ]),
                    _vm._v(" "),
                    order.SO_Number
                      ? _c("div", { staticClass: "order-number" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("tag"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(order.SO_Number))]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order-date" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("event"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.formatDate(order.Created_Time))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("SupsisButton", {
                  staticClass: "view-order-btn",
                  attrs: { icon: "open_in_new" },
                  on: {
                    click: function ($event) {
                      return _vm.gotoSalesOrderOnZoho(order.id)
                    },
                  },
                }),
                _vm._v(" "),
                _c("a-divider"),
              ],
              1
            )
          }),
          0
        )
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [
            _c("span", [_vm._v(_vm._s(_vm.$t("message.loadingSalesOrders")))]),
            _vm._v(" "),
            _c("BucketSpinner", { staticClass: "large-spinner" }),
          ],
          1
        )
      : _c("div", { staticClass: "empty-orders-container" }, [
          _c("span", { staticClass: "material-icons empty-icon" }, [
            _vm._v("shopping_cart"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "empty-text" }, [
            _vm._v(_vm._s(_vm.$t("message.noSalesOrdersFound"))),
          ]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }